import React from 'react'
import { groupBy } from 'lodash'

import { getBenefitsByCategory } from 'store/benefit/actions'
import * as simulatorActions from 'store/simulator/actions'
import CalcDetail from 'components/CalcDetail'
import BagInfo from 'components/BenefitDetail/BagInfo'
import BenefitInfo from 'components/BenefitDetail/BenefitInfo'
import BenefitDetail from 'components/BenefitDetail'
import ProviderInfo from './ProviderInfo'
import './SavingsInsurancePage.scss'
import { withTranslation, WithTranslation } from 'react-i18next'
import ProvidersStep from "./ProvidersStep/ProvidersStep"
import ProductsStep from "./ProductsStep/ProductsStep"
import GeneralProduct from '../GeneralProduct'
import { Button } from 'reactstrap'
import { getActiveModificationWindow } from "../../../helpers/getActiveModificationWindow"
import { showNotify } from "../../../utils/notify"

interface Props {
  benefits: Benefit[]
  contract: Contract[]
  simulation: Simulation
  onChange: () => void
  dispatch: (action: any) => Promise<any> | void
  user?: any
}

interface States {
  price: number
  details: object
  currentStep: number
  selectedProvider: Provider
  selectedBenefit: Benefit
  existingContract: Contract | null
}

class SavingsInsurancePage extends React.Component<Props & WithTranslation, States> {
  contract: Contract = null
  state = {
    price: 0,
    details: {},
    currentStep: 0,
    selectedProvider: null,
    selectedBenefit: null,
    existingContract: null,
  }

  constructor(props) {
    super(props)

    const existingContract = ((props.user && props.user.contracts) || []).find(
        (contract: Contract) => contract.product === 'saving-plan' && contract.status !== 'cancelled'
    )
    this.state = {
      price: 0,
      details: {},
      currentStep: 0,
      selectedProvider: null,
      selectedBenefit: null,
      existingContract,
    }

    this.props.dispatch(getBenefitsByCategory('saving-plan'))
  }

  componentDidUpdate(prevProps) {
    // Solo si llegan los beneficios Y todavía no se había seleccionado (primer load):
    if (
        this.props.benefits !== prevProps.benefits &&
        this.state.existingContract &&
        this.props.benefits.length > 0 &&
        !this.state.selectedBenefit
    ) {
      const existingContract = this.state.existingContract
      const contractBenefitModalityId =
          existingContract.benefit?.modalityId ||
          existingContract.benefitId ||
          null

      const selectedBenefit = this.props.benefits.find(
          (b) => b.modalityId === contractBenefitModalityId
      ) || null

      const selectedProvider = selectedBenefit?.provider || null

      // Solo si cambiamos el step, actualizamos:
      this.setState({
        selectedBenefit,
        selectedProvider,
        currentStep: selectedBenefit ? 2 : 0,
      })
    }
  }

  handleCompanySelect = (provider: Provider) => {
    // move next
    this.setState({
      currentStep: this.state.currentStep + 1,
      selectedProvider: provider,
    })
  }

  handlePrevStep = () => {
    this.setState({
      currentStep: Math.max(0, this.state.currentStep - 1),
    })
    if (this.contract) {
      this.props.dispatch(simulatorActions.removeItem(this.contract.id))
      this.contract = null
    }
  }

  handleBenefitSelect = (benefit: Benefit) => {
    this.setState({
      currentStep: this.state.currentStep + 1,
      selectedBenefit: benefit,
    })
  }

  isModificationAllowed = () => {
    const { existingContract } = this.state
    if (!existingContract) return true
    const today = new Date()
    const windowName = getActiveModificationWindow(today)

    return !(
        existingContract.product === 'saving-plan' &&
        existingContract.status === 'contracted' &&
        !windowName
    )
  }

  handleBackToSelection = () => {
    const { cart, t } = this.props as any

    // Busca un saving-plan en estado pendiente o contratado para ese producto
    const savingPlanEnProceso = cart.some(
        c => c.product === 'saving-plan' && (c.status === 'cart')
    )


    if (savingPlanEnProceso) {
      showNotify(
          t('contracts.saving_in_progress_error'),
          'error'
      )
      return
    }

    // Si no hay saving-plan pendiente, permite volver
    this.setState({ currentStep: 1 })
  }



  render() {
    const { benefits, t, simulation } = this.props
    const { currentStep, selectedProvider, selectedBenefit, existingContract } = this.state

    const groupedBenefits = groupBy(benefits || [], 'providerId')

    const providers = Object.values(groupedBenefits)
        .map(item => item && item[0] && item[0].provider)
        .filter(Boolean)


    const steps =
      providers.length > 1
        ? ['cart.basket_selection', 'cart.step_months', 'cart.step_family']
        : ['cart.basket_selection', 'cart.step_months']

    return (
      <div className="savings-insurance-page">
        <div className="product-container">
          <div className="product-col">
            {currentStep === 2 && existingContract && this.isModificationAllowed() && (
                <div className="step2-top-actions mb-3 d-flex align-items-center justify-content-between">
              <span className="font-weight-bold">
                {t('cart.step_months')}
              </span>
                  <Button
                      color="link"
                      className="p-0 text-primary"
                      onClick={this.handleBackToSelection}
                      title={t('cart.basket_selection')}
                  >
                    <i className="fa fa-arrow-left mr-2" />
                    {t('cart.basket_selection')}
                  </Button>
                </div>
            )}
            {currentStep === 2 ? (
              <BenefitInfo benefit={selectedBenefit} />
            ) : (
              <ProviderInfo provider={selectedProvider} benefit={benefits[0]} />
            )}

            <BagInfo benefit={selectedBenefit} />

            {simulation && simulation.available > 0 ?

              <div className="form-wizard">
                <ul>
                  {steps.map((step, index) => {
                    let className = ''
                    if (currentStep > index) {
                      className = 'completed'
                    } else if (currentStep === index) {
                      className = 'active'
                    }
                    return (
                      <li key={step} className={className}>
                        {/* eslint-disable-next-line*/}
                        <a>
                          <span>{index + 1}</span>
                          {t(step)}
                        </a>
                      </li>
                    )
                  })}
                </ul>
                <div className="mt-5" />

                {currentStep === 0 && (
                  <ProvidersStep
                    providers={providers}
                    onSubmit={this.handleCompanySelect}
                  />
                )}

                {currentStep === 1 && (
                  <ProductsStep
                      benefits={(selectedProvider && groupedBenefits[selectedProvider.id]) || []}
                      onPrev={this.handlePrevStep}
                      onSubmit={this.handleBenefitSelect}
                  />
                )}

                {currentStep === 2 && (
                  <BenefitDetail
                    benefit={selectedBenefit}
                    EditComponent={GeneralProduct}
                    onPrev={this.handlePrevStep}
                    showBack
                    hideBagInfo
                  />
                )}
              </div>
            :   <div className="alert alert-danger" role="alert">
                  {t('HEADER.LIMIT')} {t('HEADER.REACHED')}
                </div>
            }

          </div>
          <div className="calc-col">
            <CalcDetail {...this.props} />
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(SavingsInsurancePage)